import { Component, OnInit, Input } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import { RequestEndorseSubject } from '../../../shared/request-endorse-subject.model';

@Component({
  selector: 'app-information-saved',
  templateUrl: './information-saved.component.html',
  styleUrls: ['./information-saved.component.scss']
})
export class InformationSavedComponent implements OnInit {
  @Input() tittle: String;
  @Input() subjects: RequestEndorseSubject[];
  @Input() yesEndorse = true;
  autFormControl = new FormControl('', [
    Validators.required
  ]);

  numeFormControl = new FormControl('', [
    Validators.required
  ]);


  dateFormControl = new FormControl('', [
    Validators.required
  ]);

  jusFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor() { }

  ngOnInit() {
  }

}
